import { Component } from "preact";
import { connectWithTranslations } from "../../../../common/helpers/translationsHelpers";
import { CATEGORY_FILTER_OPTIONS, GA4EVENT, GTM_ID } from "../../../constants";
import CheckboxPicker from "../../../../common/components/CheckboxPicker";
import { getKeysOfNotNullValues } from "../../../../common/helpers/objects";

class AdvancedCategoryFilterDesktop extends Component {
    componentWillMount() {
        const selectedCategories = this.props.selectedCategories;
        const categories = getKeysOfNotNullValues(CATEGORY_FILTER_OPTIONS);

        const selected =
            selectedCategories.length === 0
                ? []
                : categories.filter((key) =>
                    selectedCategories.includes(CATEGORY_FILTER_OPTIONS[key])
                );

        this.setState({
            selected,
            categories,
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.selectedCategories !== nextProps.selectedCategories) {
            const selected = this.state.categories.filter((key) =>
                nextProps.selectedCategories.includes(
                    CATEGORY_FILTER_OPTIONS[key]
                )
            );
            this.setState({ selected });
        }
    }

    render({ onChange, translate, config }, { selected, categories }) {
        return (
            <div>
                <CheckboxPicker
                    onChange={(values) =>
                        onChange(values.map((x) => CATEGORY_FILTER_OPTIONS[x]))
                    }
                    values={categories}
                    checkedValues={selected}
                    renderTitle={() => (
                        <h4 class="fxs_headline_tiny fxs_marginBase_vertical">
                            {translate("CategoryFilterTitle")}
                        </h4>
                    )}
                    renderValue={(value) => <span>{translate(value)}</span>}
                    getOptionGtmId={(key) =>
                        config.tracking &&
                        GTM_ID.ADVANCED_FILTERS_CATEGORY_CHECKBOX(
                            key.replace("Category_", "").toLowerCase()
                        )
                    }
                    getOptionGA4Id={(key) =>
                        config.tracking &&
                        GA4EVENT.ELEMENTS.ADVANCED_FILTERS_CATEGORY_CHECKBOX(
                            key.replace("Category_", "").toLowerCase()
                        )
                    }
                    getGa4Name={
                        config.tracking &&
                        GA4EVENT.NAMES.FEATURES_CALENDAR
                    }
                />
            </div>
        );
    }
}

export default connectWithTranslations("config")(AdvancedCategoryFilterDesktop);
